import { makeStyles } from '@fluentui/react-components';

export const useStyles = makeStyles({
  progressViewerContainer: {
    display: 'flex',
    width: '420px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '0px 10px 10px 10px',
    gap: '10px',
    '@media (max-width: 768px)': {
      width: '100%',
      maxWidth: '420px',
      padding: '0px 0px 10px 0px',
    },
  },
  progressViewerBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    borderRadius: '16px',
    border: '1px solid rgba(0, 0, 0, 0.10)',
    background: '#FFF',
    width: '100%',
  },
  progressViewerTitle: {
    display: 'flex',
    padding: '24px 24px 16px 24px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    alignSelf: 'stretch',
    borderBottom: '1px solid rgba(0, 0, 0, 0.10)',
    // width: '100%',
  },
  progressViewerTitleAllCompleted: {
    borderBottom: 'none',
  },
  progressViewerTitleContent: {
    flex: '1 0 0',
    color: '#000',
    fontFamily: 'Montserrat',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '24px',
    textTransform: 'uppercase',
    opacity: 0.5,
  },
  collapseButton: {
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '4px',
    borderRadius: '4px',
    transition: 'background-color 0.2s ease',
    '&:hover': {
      background: 'rgba(0, 0, 0, 0.05)',
    },
    '&:focus': {
      outline: 'none',
    },
  },
  privacyInsightDisclaimer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
    alignSelf: 'stretch',
  },
  privacyInsightIcon: {
    display: 'flex',
    width: '16px',
    height: '16px',
    justifyContent: 'center',
    alignItems: 'center',
    opacity: 0.4,
  },
  privacyInsightContent: {
    color: '#000',
    fontFamily: 'Montserrat',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '18px',
    letterSpacing: '-0.12px',
    opacity: 0.4,
  },
  progressViewerSkeleton: {
    display: 'flex',
    flexDirection: 'column',
    width: '380px',
    gap: '8px',
    padding: '20px',
  },
  progressViewerSkeletonItem: {
    width: '100%',
    paddingTop: '8px',
    paddingBottom: '8px',
  },
  stepsContainer: {
    width: '100%',
    overflow: 'hidden',
    transition: 'max-height 0.3s ease-in-out',
  },
  expanded: {
    maxHeight: '1000px', // Large enough to fit all steps
  },
  collapsed: {
    maxHeight: '110px', // Approximately the height of a single step
  },
});
